import React from 'react';
import './BecomeASellerMadeInIndia.scss';
import { Typography } from '@mui/material';
import PublicIcon from '@mui/icons-material/Public';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PeopleIcon from '@mui/icons-material/People';
import EmojiEventsIcon from '@mui/icons-material/EmojiEvents';
import FavoriteIcon from '@mui/icons-material/Favorite';
import LanguageIcon from '@mui/icons-material/Language';

const BecomeASellerMadeInIndia = () => {
  const statistics = [
    {
      id: 1,
      icon: PublicIcon,
      number: "70%",
      description: "Of global IT services powered by Indian professionals"
    },
    {
      id: 2,
      icon: TrendingUpIcon,
      number: "#1",
      description: "Fastest growing freelance market worldwide"
    },
    {
      id: 3,
      icon: PeopleIcon,
      number: "15M+",
      description: "Indian freelancers contributing globally"
    },
    {
      id: 4,
      icon: EmojiEventsIcon,
      number: "Top 3",
      description: "In software development and digital services globally"
    }
  ];

  const features = [
    {
      title: "Local Understanding",
      description: "We know the challenges Indian freelancers face - from payment delays to cultural barriers."
    },
    {
      title: "Global Ambition",
      description: "While rooted in India, we're building a platform for worldwide success."
    },
    {
      title: "Community First",
      description: "Your success is our success. Without your support, this vision is impossible."
    }
  ];

  return (
    <div className="become-freelancer-made-in-india">
      <div className="made-in-india-container">
        {/* First Section - Statistics */}
        <div className="statistics-section">
          <div className="statistics-header">
            <div className="made-in-india-tag">
              <FavoriteIcon className="tag-icon" />
              <Typography variant="body2" className="tag-text">
                Proudly Made in India
              </Typography>
            </div>
            <Typography variant="h3" className="statistics-title">
              India: The World's Back Office & Beyond
            </Typography>
            <Typography variant="h6" className="statistics-subtitle">
              "They say, India is the back office of the whole world." But we know it's much more than that. Indian-origin professionals are leading global innovation, and freelancing is where we need crystal clear direction and organization. <span className="highlight-text">That's why GenieGig is here.</span>
            </Typography>
          </div>

          <div className="statistics-grid">
            {statistics.map((stat) => {
              const IconComponent = stat.icon;
              return (
                <div key={stat.id} className="stat-card">
                  <div className="stat-icon">
                    <IconComponent className="icon" />
                  </div>
                  <Typography variant="h3" className="stat-number">
                    {stat.number}
                  </Typography>
                  <Typography variant="body2" className="stat-description">
                    {stat.description}
                  </Typography>
                </div>
              );
            })}
          </div>
        </div>

        {/* Second Section - Built by Indians */}
        <div className="built-by-indians-section">
          <div className="built-by-indians-content">
            {/* Left Column */}
            <div className="left-column">
              <div className="built-by-tag">
                <FavoriteIcon className="tag-icon" />
                <Typography variant="body2" className="tag-text">
                  Built by Indians, For Indians
                </Typography>
              </div>
              <Typography variant="h4" className="built-by-title">
                GenieGig is more than just a platform - it's a movement to organize and elevate Indian freelancing talent. Our super team works day and night to turn this unique model into a global success story.
              </Typography>
              <div className="features-list">
                {features.map((feature, index) => (
                  <div key={index} className="feature-item">
                    <div className="feature-bullet"></div>
                    <div className="feature-content">
                      <Typography variant="h6" className="feature-title">
                        {feature.title}
                      </Typography>
                      <Typography variant="body2" className="feature-description">
                        {feature.description}
                      </Typography>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            {/* Right Column */}
            <div className="right-column">
              <div className="cta-card">
                <div className="cta-icon">
                  <LanguageIcon className="icon" />
                </div>
                <Typography variant="h4" className="cta-title">
                  Join the Revolution
                </Typography>
                <Typography variant="body2" className="cta-subtitle">
                  Be part of the movement that's redefining how Indian talent connects with global opportunities.
                </Typography>
                <div className="progress-section">
                  <div className="progress-labels">
                    <Typography variant="body2" className="progress-label">
                      Platform Progress
                    </Typography>
                    <Typography variant="body2" className="progress-label growing">
                      Growing Daily
                    </Typography>
                  </div>
                  <div className="progress-bar">
                    <div className="progress-fill"></div>
                  </div>
                  <Typography variant="body2" className="progress-text">
                    Together, we're building something extraordinary.
                  </Typography>
                </div>
              </div>
            </div>
          </div>

          {/* Bottom Quote */}
          <div className="bottom-quote">
            <Typography variant="h6" className="quote-text">
              "We are here for you. Your journey, your success, your dreams - that's what drives us every single day."
            </Typography>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BecomeASellerMadeInIndia;
